import { Modal } from '@studio/components';

import { KycRequired } from '@src/components';

import styles from './KycPopup.module.css';

interface KycPopup extends React.ComponentProps<typeof KycRequired> {
  onClose: VoidFunction;
}

export const KycPopup = ({ onClose, isOrgOwner }: KycPopup) => {
  return (
    <Modal
      show
      title='KYC required'
      classes={{ body: styles.dialogBody }}
      footer={<></>}
      onClose={onClose}
    >
      <KycRequired isOrgOwner={isOrgOwner} />
    </Modal>
  );
};
